import GUI, { IGUIProps } from "../GUI"

export default function Spinner(props:IGUIProps){
    return <div className={GUI.joinClass("spinner", props.className)}>
        <div className="spin"/>
    </div>
}